import BulkCreateBranchSelect from "./bulkCreateBranchSelect.container";

export default BulkCreateBranchSelect;
